export const configuredLines = configuredLinesString => (configuredLinesString ?? '').split(';').filter(Boolean);
